export default __webpack_public_path__ + "static/media/beverages-vegshelf.0cea8f88.png";